import Shipment from '../../../types/api/shipment'
import Stock from '../../../types/api/stock'

export function areMaterialRequirementsHandled(
    shipment: Shipment | undefined | null,
    stocks?: Stock[]
): boolean {
    if (!shipment) {
        return false
    }

    const hasReserve = !!shipment.materialRequirements?.some(requirement =>
        requirement.configurations?.some(config => {
            const relevantStocks = stocks
                ? stocks.filter(stock => stock.material?.documentId === config.material?.documentId)
                : config.material?.stocks || []

            return relevantStocks.some(stock =>
                stock.stock_reserves?.some(
                    reserve =>
                        reserve.shipment?.documentId === shipment.documentId &&
                        reserve.amount === config.amount
                )
            )
        })
    )

    const hasOrderRequest =
        !!shipment.materialRequirements?.some(requirement =>
            requirement.configurations?.some(config => config.action === 'Заказать')
        ) && !!shipment.tasks?.some(task => task.type === 'Заказ форм')

    const hasCutTask =
        !!shipment.materialRequirements?.some(requirement =>
            requirement.configurations?.some(config => config.action === 'Разрезать')
        ) && !!shipment.tasks?.some(task => task.type === 'Разрез материала')

    return hasReserve || hasOrderRequest || hasCutTask
}
